import React, { useEffect } from 'react';
import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../../utils/languageRouter';

const LanguageRouter = () => {
  const { lang } = useParams();
  const { changeLanguage } = useLanguage();
  
  // ✅ 移除 console.log，保留功能
  useEffect(() => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return;
    if (localStorage.getItem('language') !== lang) {
      changeLanguage(lang);
    }
  }, [lang, changeLanguage]);

  if (!lang || !SUPPORTED_LANGUAGES.includes(lang)) {
    const userLang = localStorage.getItem('language') || DEFAULT_LANGUAGE;
    const redirectPath = window.location.hash.replace('#/', '');
    const newPath = redirectPath.includes('/') 
      ? `/${userLang}/${redirectPath.split('/').slice(1).join('/')}` 
      : `/${userLang}`;
    return <Navigate to={newPath} replace />;
  }

  return <Outlet />;
};

export default LanguageRouter;